module.exports = __webpack_public_path__ + "img/h-logo.8552f672.8552f672.png";